module.exports = __webpack_public_path__ + "img/rongyu2.b8e8a925.jpg";